/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commonnetworkerrortitle3Inputs */



/**
* | output |
* | --- |
* | "Network error" |
*
* @param {Commonnetworkerrortitle3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const commonnetworkerrortitle3 = /** @type {((inputs?: Commonnetworkerrortitle3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commonnetworkerrortitle3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Network error")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error de red")
	return /** @type {LocalizedString} */ ("Ошибка сети")
});
export { commonnetworkerrortitle3 as "commonNetworkErrorTitle" }